import { GroupResponse } from "../contracts/GroupResponse";
import { Group } from "../models/Group";

/** Maps API group responses to frontend Group models */
export class GroupResponseMapper {
  /** Converts a single GroupResponse to a Group model */
  toGroup = (response: GroupResponse): Group => {
    return {
      id: response.id,
      organizationId: response.organizationId,
      name: response.name,
      description: response.description,
      tags: response.tags ?? [],
      dateCreated: new Date(response.dateCreated),
      dateModified: new Date(response.dateModified),
    };
  };

  /** Converts an array of GroupResponse to Group models */
  toGroups = (responses: GroupResponse[]): Group[] => {
    return responses.map((response) => this.toGroup(response));
  };
}
